import * as Yup from 'yup';

export type TInitialValues = {
    code: string;
};

export const initialValues: TInitialValues = {
    code: '',
};

export const validation = Yup.object().shape({
    code: Yup.string()
        .required('Tento údaj je povinný')
        .length(6, 'Kód musí mať presne 6 znakov'),
});